// https://docs.google.com/spreadsheets/d/1O2AbgZ4DlkuXegEOcfRbcb71pKRFPt3CgGDLFw8vlpQ/edit#gid=2073249340

// #4
export function globalNavAccountBtnOnHoverEvent(track) {
  const trackingData = {
    event: 'navigate',
    componentType: 'top-nav',
    action: 'view',
    title: 'profile-button-menu',
  };

  track({ data: trackingData });
}

// #5
export function globalNavAccountBtnClickEvent(track) {
  const trackingData = {
    event: 'signupNow',
    componentType: 'top-nav|signup',
    position: 0,
  };

  track({ data: trackingData });
}

// #6
export function globalNavSigninBtnClickEvent(track) {
  const trackingData = {
    event: 'signupNow',
    componentType: 'top-nav|signin',
    position: 1,
  };

  track({ data: trackingData });
}

// #7
export function globalNavSignupBtnClickEvent(track) {
  const trackingData = {
    event: 'signupNow',
    componentType: 'top-nav|signup',
    position: 2,
  };

  track({ data: trackingData });
}

// #8
export function globalNavLearnMoreBtnClickEvent(track) {
  const trackingData = {
    event: 'navigate',
    componentType: 'top-menu',
    action: 'click',
    title: 'learn-more',
  };

  track({ data: trackingData });
}

export default {
  globalNavAccountBtnOnHoverEvent,
  globalNavAccountBtnClickEvent,
  globalNavSigninBtnClickEvent,
  globalNavSignupBtnClickEvent,
  globalNavLearnMoreBtnClickEvent,
};
